module.exports = __webpack_public_path__ + "static/hex-5babf7d3c65c98012ce5fbcd1e6889d5.png";